import { useEffect } from 'react';

import { checkCondition2, checkShouldClean } from '@/shared/_legacy_/condition-utils';
import { BaseDto } from '@/shared/lib/sj-orm/models/base.dto';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';

import { UseFormRenderInputType } from '../types';

export const useCleanValuesOnDisabledIfChange = <
  TDto extends Omit<BaseDto, 'id'>,
  THelp extends { [TKey in keyof TDto]: QuestionType },
>({
  sectionItems,
  prevForceReRender,
  forceReRender,
  form,
}: UseFormRenderInputType<TDto, THelp> & {
  prevForceReRender?: Record<string, unknown>;
  forceReRender: Record<string, unknown>;
}) => {
  useEffect(() => {
    if (!sectionItems || !prevForceReRender) return;

    Object.entries(sectionItems).forEach(([fieldName, question]) => {
      const shouldClean = checkShouldClean(question.disableIf);

      if (question.disableIf && shouldClean) {
        const isNowDisabled = !checkCondition2(forceReRender, question.disableIf);
        const wasDisabled = !checkCondition2(prevForceReRender, question.disableIf);

        if (isNowDisabled && !wasDisabled) {
          const currentValue = form.getValues(fieldName as never);
          if (currentValue !== undefined && currentValue !== null && currentValue !== '') {
            form.setValue(fieldName as never, undefined as never, { shouldValidate: false });
          }
        }
      }
    });
  }, [forceReRender, prevForceReRender, sectionItems, form]);
};
